import { render } from "./RejectedBoxesAndItems.vue?vue&type=template&id=e14d10cc"
import script from "./RejectedBoxesAndItems.vue?vue&type=script&lang=js"
export * from "./RejectedBoxesAndItems.vue?vue&type=script&lang=js"

import "./RejectedBoxesAndItems.vue?vue&type=style&index=0&id=e14d10cc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__